export function findDiffIndex(a, b) {
    const maxLength = Math.max(a.length, b.length)

    for (let i = 0; i < maxLength; i++) {
        if (a[i] !== b[i]) {
            return i
        }
    }

    return -1
}

export function substitute(str, object, regexp){
    return String(str).replace(regexp || (/\\?\{([^{}]+)\}/g), function(match, name){
        if (match.charAt(0) == '\\') return match.slice(1);
        return (object[name] != null) ? object[name] : '';
    });
}
